// extracted by mini-css-extract-plugin
export default {"l":"_9dc8d07f7b"};